import { useMemo } from "preact/hooks";
import type { RoutableProps } from "preact-router";
import { LegalFooter } from "../components/footer";
import { STRINGS } from "../constants/strings";
import type { ErrorType } from "../types";

interface Props extends RoutableProps {
  type?: string;
}

interface ErrorView {
  icon: string;
  modifier: string;
  title: string;
  body: string;
}

const VALID_TYPES: ErrorType[] = [
  "already",
  "expired",
  "invalid",
  "duplicate",
  "used",
];

function buildView(type: ErrorType, params: URLSearchParams): ErrorView {
  const company = params.get("company") || "";
  const date = params.get("date") || "";
  switch (type) {
    case "already":
      return {
        icon: "task_alt",
        modifier: "",
        title: STRINGS.errorAlreadyTitle,
        body: STRINGS.errorAlreadyBody(date),
      };
    case "expired":
      return {
        icon: "link_off",
        modifier: "tl-icon-circle--error",
        title: STRINGS.errorExpiredTitle,
        body: STRINGS.errorExpiredBody,
      };
    case "invalid":
      return {
        icon: "error_outline",
        modifier: "tl-icon-circle--error",
        title: STRINGS.errorInvalidTitle,
        body: STRINGS.errorInvalidBody,
      };
    case "duplicate":
      return {
        icon: "history",
        modifier: "tl-icon-circle--amber",
        title: STRINGS.errorDuplicateTitle,
        body: STRINGS.errorDuplicateBody(company),
      };
    case "used":
      return {
        icon: "link",
        modifier: "tl-icon-circle--amber",
        title: STRINGS.errorUsedTitle,
        body: STRINGS.errorUsedBody,
      };
  }
}

export function ErrorScreen({ type }: Props) {
  const params = useMemo(
    () => new URLSearchParams(window.location.search),
    []
  );
  const safeType: ErrorType = VALID_TYPES.includes(type as ErrorType)
    ? (type as ErrorType)
    : "invalid";
  const view = buildView(safeType, params);
  const cls = ("tl-icon-circle " + view.modifier).trim();

  return (
    <div class="tl-page">
      <div class="tl-page-centered">
        <div class={cls}>
          <span class="material-icons" aria-hidden="true">
            {view.icon}
          </span>
        </div>
        <h1 class="tl-screen-title">{view.title}</h1>
        <p class="tl-screen-body">{view.body}</p>
      </div>
      <LegalFooter />
    </div>
  );
}
